import script from "./UserTripDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTripDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./UserTripDetailsPage.vue?vue&type=style&index=0&id=2d08f46e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d08f46e"]])

export default __exports__